module.exports = __webpack_public_path__ + "static/media/puzzle03.3e4201f7.png";